<!--
 * @Author       : Tom
 * @Date         : 2019-12-21 23:50:12
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-20 16:03:20
 * @FilePath     : /shop_front_end/src/views/shop_set/editor.vue
 * @Description  : 店铺设置 编辑
 -->
<template>
  <div class="shopset">
    <a-card title="编辑店铺信息" :bordered="false">
      <a-form class="storedata" :form="form">
        <a-form-item label="店铺头像" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" style="display: flex;align-items: center;">
          <div class="headImg">
            <img :src="headImg" alt="">

            <span>修改头像</span>

            <input @change="changeHead" type="file" accept="image/*">
            <a-input type="hidden" v-decorator="['logo', { rules: [{ required: true }], initialValue: '110' }]"/>
          </div>
          <!--
           <a-upload :action="downloadURL" listType="picture-card" :fileList="fileList" @preview="handlePreview" @change="handleChange" :headers="heads">
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload> -->

        </a-form-item>

        <a-form-item label="店铺名称" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-input type="text" style="width:304px;" v-decorator="['name', { initialValue: name }]"></a-input>
        </a-form-item>

        <a-form-item label="店铺信息" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-textarea style="width:304px;" v-decorator="['shop_information', { rules: [{ required: true }], initialValue: shop_information }]" :autosize="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>

        <a-form-item label="经营范围" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-input style="width:304px;" v-decorator="['shop_range', { rules: [{ required: true }], initialValue: shop_range }]"></a-input>
        </a-form-item>

        <a-form-item label="营业状态" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-radio-group v-decorator="['is_open', { rules: [{ required: true }], initialValue: is_open }]">
            <a-radio :value="1">营业</a-radio>
            <a-radio :value="2">打烊</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="用户姓名" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <span>{{ realname }}</span>
        </a-form-item>

        <a-form-item label="身份证号" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <span>{{ ID_number }}</span>
        </a-form-item>

        <a-form-item label="联系电话" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-input style="width:304px;" v-decorator="['tel', { rules: [{ required: true }], initialValue: tel }]"></a-input>
        </a-form-item>

        <a-form-item label="选择地区" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-input type="hidden" v-decorator="['area1', { rules: [{ required: true }], initialValue: 'tel' }]"></a-input>

          <a-form-item style="width: 110px;display: inline-block;margin-right: 8px;">
            <a-select placeholder="省" @change="changeSheng" data-level="1" v-decorator="['sheng', { initialValue: addressObj.sheng }]" style="width: 110px">
              <a-select-option v-for="item,index of shenOptions" :key="item.GroupID" :value="item.GroupID">
                {{item.G_CName}}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="width: 110px;display: inline-block;margin-right: 8px;">
            <a-select @change="changeShi" data-level="2" placeholder="市" v-decorator="['shi', { initialValue: addressObj.shi }]" style="width: 110px">
              <a-select-option v-for="item,index of shiOptions" :key="item.GroupID" :value="item.GroupID">
                {{item.G_CName}}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="width: 110px;display: inline-block">
            <a-select placeholder="区" v-decorator="['xian', { initialValue: addressObj.xian }]" style="width: 110px">
              <a-select-option v-for="item,index of xianOptions" :key="item.GroupID" :value="item.GroupID">
                {{item.G_CName}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form-item>

        <a-form-item label="详细地址" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-input placeholder="请输入详细地址" v-decorator="['address', { rules: [{ required: true }], initialValue: address }]" style="width: 346px;"></a-input>
        </a-form-item>

        <a-form-item label="客服" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
          <a-textarea

              v-decorator="['mch_service', { initialValue: mch_service }]"
              placeholder="请输入客服地址"
              :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>

      </a-form>

      <div class="foot">
        <a-button type="primary" ghost class="btns" @click="onGoBack">取消</a-button>
        <a-button type="primary" @click="onFormBtn">保存</a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
import { downloadURL } from '../../lib/config';
import { getToken } from '../../lib/tool';

export default {
  data() {
    return {
      downloadURL,
      form: this.$form.createForm(this, { name: 'coordinated' }),
      userimg: '',
      name: '',
      shop_information: '',
      shop_range: '',
      tel: '',
      realname: '',
      address: '',
      ID_number: '',
      previewVisible: false,
      previewImage: '',
      fileList: [],
      heads: {},

      is_open: undefined,
      addressObj: {},
      shenOptions: [],
      shiOptions: [],
      xianOptions: [],
      areaLevel: 0,
      mch_service: '',
      headImg: ''
    };
  },
  mounted() {
    let token = getToken('token');
    this.heads = {
      Authorizations: 'Bearer ' + token
    };

    this.initPage();
  },
  methods: {
    changeHead(e){
      var data = new FormData();
      var file = e.target.files;
      data.append('file', file[0]);

      this.$request.post(this.downloadURL,data).then(res=>{
        if(res.code == 200){
          this.headImg = res.data.url
        }
      })

    },
    async edit_getAdd(sheng_id,shi_id){
      await this.getAddress();
      if(sheng_id){
        await this.changeSheng(sheng_id,true);
      }
      if(shi_id){
        await this.changeShi(shi_id,true);
      }
    },
    async changeSheng(id,flag){
      this.areaLevel = 1

      if(flag!==true){
        this.addressObj.shi = undefined
        this.addressObj.xian = undefined
      }

      return this.getAddress(id)
    },
    async changeShi(id,flag){
      this.areaLevel = 2

      if(flag!==true){
        this.addressObj.xian = undefined
      }

      return this.getAddress(id)
    },
    getAddress(GroupID){
      let data = {
        GroupID
      }

      return this.$request.post('?module=pc_api&action=Mch&app=mch_address', data).then(res => {
        let { code, message, data } = res;
        if (code === 200) {
          if(this.areaLevel == 0){
            this.shenOptions = data
            this.shiOptions = []
            this.xianOptions = []
          }else if(this.areaLevel == 1){
            this.shiOptions = data
            this.xianOptions = []
            this.form.resetFields(['shi','xian'])
          }else{
            this.xianOptions = data
            this.form.resetFields(['xian'])
          }
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    /**
     * @name 返回
     * */

    onGoBack() {
      this.$router.push('/shopset');
    },
    /**
     * @name 初始化页面
     */
    initPage() {
      this.$request.get('?module=pc_api&action=Mch&app=Index&shop_id=2').then(res => {
        let { code, meaasge, data } = res;

        if (code === 200) {
          if (data.length) {
            let { logo, name, realname, shop_information, mch_service,shop_range, tel, address, ID_number, is_open, sheng_id, shi_id, xian_id } = data[0];

            if(sheng_id == '0'){
              sheng_id = undefined
            }
            if(shi_id == '0'){
              shi_id = undefined
            }
            if(xian_id == '0'){
              xian_id = undefined
            }

            Object.assign(this, {
              userimg: logo,
              name: name,
              realname: realname,
              shop_information: shop_information,
              shop_range: shop_range,
              tel: tel,
              address: address,
              ID_number: ID_number,
              mch_service: mch_service,
              headImg: logo,
              is_open: Number(is_open),
              addressObj: {
                sheng: sheng_id,
                shi: shi_id,
                xian: xian_id,
              }
            });

            this.edit_getAdd(sheng_id,shi_id)
          }
        } else {
        }
      });
    },
    onFormBtn() {
      this.form.validateFields((err, values) => {
        console.log(values)
        if (!err) {
          // let file = this.fileList[this.fileList.length - 1];
          // console.log(file)
          // if (file && file.url) {
          // 	values.logo = file.url;
          // }

          // if (file && file.response) {
          // 	values.logo = file.response.url;
          // }

          values.logo = this.headImg

          let { sheng, shi, xian } = values

          this.shenOptions.some(item=>{
            if(item.GroupID == sheng){
              sheng = item.G_CName
            }
          })
          this.shiOptions.some(item=>{
            if(item.GroupID == shi){
              shi = item.G_CName
            }
          })
          this.xianOptions.some(item=>{
            if(item.GroupID == xian){
              xian = item.G_CName
            }
          })
          values.city_all = sheng+'-'+shi+'-'+xian

          this.httpUpdate(values);
        }
      });
    },
    httpUpdate(values) {
      this.$request.get('?module=pc_api&action=Mch&app=edit', { params: values }).then(res => {
        let { code, message } = res;
        if (code === 200) {
          this.$message.success(message);
          setTimeout(() => {
            this.onGoBack();
          }, 600);
        } else {
          this.$message.warning(message);
        }
      });
    }
  }
};
</script>

<style lang="less">
.shopset {
  height: 100%;

  .ant-card{
	  height: 100%;
    display: flex;
    flex-direction: column;

    .ant-card-body{
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding: 0;
    }
  }

  .storedata {
	 flex: 1;
    padding-top: 40px;
    padding-left: 60px;
    margin-top: 0;
    overflow-y: auto;

    .ant-form-item{
      margin-bottom: 20px;

      .ant-form-item{
        margin-bottom: 0;
      }
    }

    .ant-form-item-control{
      line-height: 32px;
    }
    .ant-form-item-label{
      width: 80px;
      margin-right: 8px;
      line-height: 32px;

      lable{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #323544;
      }
    }

    span {
      font-size: 14px;
      font-weight: 400;
      color: rgba(50, 53, 68, 1);
    }
	
	.ant-select-arrow{
		font-size: 12px;
		font-weight: 300;
		color: rgba(0, 0, 0, 0.25);
	}

    .headImg{
      width: 60px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      position: relative;

      img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }

      span{
        display: none;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(4, 4, 4, 0.6);
        border-radius: 50%;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        padding: 0 13px;
        line-height: 18px;
        letter-spacing: 2px;
      }

      input{
        position: absolute;
        top: 0;
        left: 0;
        background-color: transparent;
        padding: 80px;
        z-index: 99;
        outline: 0;
        cursor: pointer;
      }
    }

    .headImg:hover span{
      display: flex;
    }
  }

  .foot {
    height: 68px;
    min-height: 68px;
    border-top: 1px solid #e9ecef;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0px 20px;

    .btns {
      margin-right: 10px;
    }

    .ant-btn{
      width: 100px;
      height: 32px;
      padding: 0;
    }
  }
  
  .ant-card-wider-padding .ant-card-head{
	  padding: 0 20px;
  }
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-radio-checked .ant-radio-inner::after{
  left: 50%;
  transform: scale(1) translateX(-50%);
}
</style>
